import { render, staticRenderFns } from "./newstopic.vue?vue&type=template&id=d507bf32&scoped=true&"
import script from "./newstopic.vue?vue&type=script&lang=js&"
export * from "./newstopic.vue?vue&type=script&lang=js&"
import style0 from "./newstopic.vue?vue&type=style&index=0&id=d507bf32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d507bf32",
  null
  
)

export default component.exports